<script lang="ts">
	import { browser } from '$app/environment';
	import { ABTEST_CONFIG, type ABTestName } from '$lib/constants/abtest';
	import { resetAbTestProperties, setAbTestProperties, type VariantName } from '$lib/services/tracking/abTestProperties';
	import { handleVendorConsent } from '$lib/services/tracking/didomi/consent';
	import { isNogarnish } from '$lib/utils/nogarnish';
	import { type Snippet } from 'svelte';
	import { clientGetAbTestIdentifier, getVariant } from './utils.svelte';

	interface Props {
		name: ABTestName;
		children: Snippet<[{ variantName: string }]>;
	}

	const { name: abtestName, children }: Props = $props();

	const ABTEST_DIDOMI_ID = 'abtestso-tFhHfKce';

	const { name: testName, variants } = $derived(ABTEST_CONFIG[abtestName]);

	let variantName = $state('');

	function setAbTestPropertiesWithVariant(variantName: VariantName<typeof abtestName>) {
		setAbTestProperties(testName, variantName);
	}

	function setupABTest() {
		if (!browser) return;
		const identifier = clientGetAbTestIdentifier(testName);
		if (!identifier) return;
		const { variant: selectedVariant } = getVariant({ key: testName, variants, identifier });
		setAbTestPropertiesWithVariant(selectedVariant);
		variantName = selectedVariant;
	}

	if (browser && !isNogarnish()) {
		handleVendorConsent(ABTEST_DIDOMI_ID, setupABTest, () => {
			resetAbTestProperties();
			variantName = '';
		});
	}
</script>

{@render children({ variantName })}
